<template>

<div fixed class="mr-3">
  <v-footer
    color="#ffffff"
    fixed
    >
    <span style="width:2%" v-if="showSlider && paused && !LYA">
      <!-- <v-icon @click="animate" small dark class="grey">mdi-play</v-icon> -->

        <v-img  src="../assets/img/timeline-play.png" class="mt-4 cursorhand" @click="animate" v-bind="attrs"
          v-on="on" width="45px"> </v-img>

    </span>
    <span style="width:2%" v-if="showSlider && !paused && !LYA">
      <v-icon @click="pause" small dark class="grey">mdi-pause</v-icon>
    </span>
    <span style="width:80%" v-if="showSlider">
    <v-slider
      v-if = "!LYA"
      v-model="yearSet"
      :tick-labels="ticksLabels"
      :value="ticksLabels"
      persistent-hint
      thumb-label="always"
      tick-size="6"
      :min="min_year"
      :max="max_year"
      height="30"
      color="#666666"
      track-color="#cccccc"
      track-fill-color="#cccccc"
      class="opensanslight size8 cursorhand"
      label="">
    </v-slider>
    </span>
    <span style="width:2%" v-if="showSlider" class="ml-1 text-right opensanslight size8">
      <v-checkbox class="opensanslight size8" v-model="LYA" label="" value="true"></v-checkbox>
    </span>
    <span style="width:13%" v-if="showSlider" class="opensanslight size8">

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="opensanslight size11">Latest year available</span>
        </template>
        <span>With this option activated, the map shows, for each unit, the latest year available for the selected indicator</span>
      </v-tooltip>
    </span>
    <span style="width:98%" v-if="!showSlider" class="text-center opensansbold pb-2  size14">
      {{valuesYears[0]}}
    </span>
    <div class="footerOECD OpenSansLight size9">© OECD | <span @click="showSource" class="cursorhand">Sources</span> | <span @click="showDisclaimer" class="cursorhand">Disclaimer</span> | <span><a href="https://www.oecd.org/privacy/" target=_new  class="linkfooter">OECD privacy policy</a></span> | <span><a href="https://www.oecd.org/termsandconditions/" target=_new class="linkfooter">Terms and conditions</a></span></div>
  </v-footer>     
 <!--/v-footer-->
</div>
    
</template>

<script>
import 'material-design-icons-iconfont/dist/material-design-icons.css' 

  export default {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
    name: 'YearSelector',
    beforeDestroy () {
      this.$root.$off('change_year_range', () => {}) 
    },
    props: {currentYear: Number},
    mounted () {
      console.log("*** MOUNTED YearSelector *****")
      this.$root.$on('change_year_range', (yr) => {
        console.log('On change_year_range')
        // console.log(yr)
        if (yr.length > 0) {
          let arr = []
          for (let y of yr) {
            arr.push(parseInt(y))
          }
          arr = arr.sort()
          this.valuesYears = arr
          this.min_year = arr[0]
          this.max_year = arr[arr.length - 1]
          let arr2 = []
          if (arr.length === 1) {
            arr2.push(arr[0].toString())            
            this.showSlider = false
          } else {
            this.showSlider = true
            for (let i = this.min_year ; i <= this.max_year ; i++) {
              if (arr.includes(i)) {
                arr2.push(i.toString())
              } else {
                arr2.push('')
              }
            }
          }
          this.ticksLabels = arr2
          this.valuesYears = arr
          if (arr) {
            return false
          }
          this.ticksLabels = arr2
          this.prevYear = parseInt(this.max_year)
          // this.yearSet = parseInt(this.max_year) 
          // console.log(this.yearSet)
          this.$forceUpdate()
        }
        else {
          this.valuesYears = []
          this.showSlider = false
          this.min_year = 0
          this.max_year = 0
          this.ticksLabels = yr
        }
        // this.$store.dispatch('setYears', yr)
      })
    },
    methods: {
      showSource: function () {
        this.$emit("showSource", null)
      },
      showDisclaimer: function () {
        this.$emit("showDisclaimer", null)
      },
      animate: function () {
        /*
        if (this.ind_animate === -1) {
          this.ind_animate = 0
        }
        */
        this.ind_animate = 0
        this.paused = false
        setTimeout(function () { this.walkYear() }.bind(this), this.intervalAnimation)
      },
      pause: function () {
        this.paused = true
      },
      walkYear: function () {
        if (!this.paused) {
          this.yearSet = this.valuesYears[this.ind_animate++]
          if (this.ind_animate < (this.valuesYears.length)) {
            setTimeout(function () { this.walkYear() }.bind(this), this.intervalAnimation)
          } else {
            this.ind_animate = 0
            this.paused = true
          }
        } 
      }
    },
    watch:  {
      LYA: function (lya) {
        //console.log(lya)
        this.$emit("setLastYearAvailable", lya)
      },
      currentYear: function (c) {
        // console.log(c)
        // console.log(this.valuesYears)
        // this.setFromApp = true
        this.yearSet = parseInt(c)
      },
      '$store.getters.year': function() {
        // console.log('*** watch $store.getters.year')
        // this.yearSet = this.$store.getters.year
      },
      yearSet: function (y,p) {
        //console.log(y)
        //console.log(p)
        if (this.setFromApp) {
          this.setFromApp = false
          return false
        }
        if (y === p) {
          return false
        }
        if (y === 'LYA') {
          console.log('LYA')
        } else if (this.valuesYears.includes(y) || this.valuesYears.includes(y.toString()) || p === 0) {
          if (p !== 0) {
            //console.log(this.LYA)
            if (!this.LYA) {
              this.$emit("setYear", y)
              this.ind_animate = this.valuesYears.indexOf(y)
            }
          }
        } else {
          // console.log('*** set previous value ' + p)          
          setTimeout(function () { this.yearSet = p }.bind(this), 100)
        }
      }
    },
    data: () => ({
      overlay: false,
      min_year: 0,
      ind_animate: -1,
      max_year: 0,
      yearSet : 0,
      valuesYears: [],
      prevYear: 0,
      showSlider: false,
      ticksLabels: [],
      setFromApp: false,
      paused: true,
      intervalAnimation: 200,
      LYA: false
    })

  }
</script>

<style scoped>
.footerOECD {
  width:100%;
  color: white;
  text-align: center;
  vertical-align: middle;
  background: #313b43;
  min-height: 25px;
  line-height: 25px;
}
.linkfooter {
  color: white;
  text-decoration: none;
}
</style>